// Input.tsx
import React, { useRef, useState } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { FiLock } from "react-icons/fi";
import { IoIosSearch } from "react-icons/io";
import { IInputProps } from "../../@interfaces";
import { useTheme } from "styled-components";

const Input: React.FC<IInputProps> = (props) => {
  const {
    isSearch,
    isEmail,
    isPassword,
    colorOfBorder,
    hasBackground,
    GAPVertical,
    containerStyle,
    sizeIcon,
    register,
    ...inputProps
  } = props;

  const [focused, setFocused] = useState(false);
  const theme = useTheme();

  const borderColor = focused
  ? props.colorOfBorder || theme.colors.primary
  : props.colorOfBorder || "rgb(118,118,118)";

  const containerStyleFinal = {
    marginTop: props.GAPVertical ? `${props.GAPVertical}px` : undefined,
    marginBottom: props.GAPVertical ? `${props.GAPVertical}px` : undefined,
    borderColor,
    color: focused ? borderColor : "rgb(118,118,118)",
    ...props.containerStyle,
  };

  return (
    <div
      style={containerStyleFinal}
      className={`
        relative w-full overflow-hidden px-0 py-[5px]
        transition-all duration-700
        border-b border-solid
        ${props.hasBackground ? "!border-none" : ""}       
      `}
    >
      <input
        {...inputProps}
        {...(props.register ? props.register() : {})}
        onFocus={(e) => {
          setFocused(true);
          props.onFocus?.(e);
        }}
        onBlur={(e) => {
          setFocused(false);
          props.onBlur?.(e);
        }}
        style={
          focused
            ? { borderColor: "var(--color-primary)" }
            : props.colorOfBorder
            ? { borderColor: props.colorOfBorder }
            : undefined
        }
        className={`
          w-full
          text-base sm:text-[.875rem]
          font-light
          p-[6px]
          bg-transparent
          outline-none
          transition-all duration-300
          focus:shadow-none
          border-none
          ${props.isSearch ? "pr-[25px]" : ""}
          ${props.hasBackground ? "!border !border-solid bg-white" : ""}
        `}
      />

      {props.isEmail && (
        <AiOutlineMail
          size={props.sizeIcon ?? 18}
          color={props.colorOfBorder}
          className="absolute right-0 top-1/2 -translate-y-1/2"
        />
      )}
      {props.isPassword && (
        <FiLock
          size={props.sizeIcon ?? 18}
          className="absolute right-0 top-1/2 -translate-y-1/2"
        />
      )}
      {props.isSearch && (
        <IoIosSearch
          size={props.sizeIcon ?? 18}
          className="absolute right-0 top-1/2 -translate-y-1/2 mt-[5px]"
        />
      )}
    </div>
  );
};

export default Input;